import { useState } from "react";
import {
  Card,
  Typography,
  Grid,
  TextField,
  Stack,
  Button,
  Collapse,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputAdornment,
  Box,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import FormCard from "./FormCard";
import SearchIcon from "@mui/icons-material/Search";
import MyTable from "../../components/Schedule/MyTable";
import InventoryTable from "./InventoryTable";
import PaginationComponent from "../../components/Pagination/Pagination";

const AddItem = () => {
  const isMobile = useMediaQuery("(max-width: 800px)");
  const [rows, setRows] = useState([
    {
      id: 1,
      "S.No.": 1,
      Location: "Station 1",
      Item: "Parent Station 1",
      Quantity: "25",
      Notes:
        "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used ",
      "Parent Location": "Parent Location 1 ",
    },
    {
      id: 2,
      "S.No.": 2,
      Location: "Station 2",
      Item: "Parent Station 2",
      Quantity: "53",
      Notes:
        "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used",
      "Parent Location": "Parent Location 2",
    },
    {
      id: 3,
      "S.No.": 3,
      Location: "Station 3",
      Item: "Parent Station 3",
      Quantity: "65",
      Notes:
        "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used",
      "Parent Location": "Parent Location 3",
    },
  ]);
  const [fileName, setFileName] = useState("No file chosen");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
    } else {
      setFileName("No file chosen");
    }
  };

  const selectOptions = {
    Location: [
      { value: "location1", label: "Location 1" },
      { value: "location2", label: "Location 2" },
      { value: "location3", label: "Location 3" },
    ],
  };

  let columns = [
    {
      field: "S.No.",
      headerName: "S. No.",
      sortable: false,
      flex: 1,
      minWidth: 100,
      filterable: false,
    },
    {
      field: "Location",
      headerName: "Location",
      sortable: false,
      flex: 1,
      minWidth: 150,
      filterable: false,
    },
    {
      field: "Item",
      headerName: "Item",
      sortable: false,
      flex: 1,
      minWidth: 200,
      filterable: false,
    },
    {
      field: "Quantity",
      headerName: "Quantity",
      sortable: false,
      flex: 1,
      minWidth: 150,
      filterable: false,
    },
    {
      field: "Notes",
      headerName: "Notes",
      sortable: false,
      flex: 1,
      minWidth: 300,
      filterable: false,
    },
    {
      field: "Actions",
      headerName: "Actions",
      sortable: false,
      flex: 1,
      minWidth: 150,
      filterable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <img src="/images/edit.svg"></img>
          <img src="/images/eye.svg"></img>
          <img src="/images/delete.svg"></img>
        </Box>
      ),
    },
  ];

  return (
    <>
      <FormCard
        title={<h5>Add Item</h5>}
        fields={[
          { label: "Location", type: "select" },
          { label: "Item", type: "text", placeholder: "Item" },
          { label: "Quantity", type: "text", placeholder: "Quantity" },
          { label: "Notes", type: "text", placeholder: "Notes" },
          { label: "Image", type: "file" },
        ]}
        selectOptions={selectOptions}
        onFileChange={handleFileChange}
        fileName={fileName}
        buttonText="Add Item"
      />
      {/* <Card className="shadow p-3 " style={{ marginTop: "1rem" }}>
        <Typography variant="h5" fontWeight={700}>
          Add Item
        </Typography>
        <Grid
          container
          spacing={3}
          //   columns={{ xs: 3, sm: 3, md: 2 }}
          className="mx-0 my-4"
        >
          <Grid item xs={12} sm={6} md={4} className="p-0 pe-5 mb-3">
            <Stack spacing={1}>
              <label>Location</label>
              <TextField select></TextField>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6} md={4} className="p-0 pe-5 mb-3">
            <Stack spacing={1}>
              <label>Item</label>
              <TextField placeholder="Item"></TextField>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6} md={4} className="p-0 pe-5 mb-3">   
            <Stack spacing={1}>
              <label>Quantity</label>
              <TextField placeholder="Quantity"></TextField>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6} md={4} className="p-0 pe-5 mb-3">
            <Stack spacing={1}>
              <label>Notes</label>
              <TextField placeholder="Notes"></TextField>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6} md={4} className="p-0 pe-5 mb-3">
            <Stack spacing={1}>
              <label>Image</label>
              <Box display="flex" alignItems="center">
                <input
                  type="file"
                  id="file-upload"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                <TextField
                  fullWidth
                  value={fileName}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <ButtonTheme
                          variant="contained"
                          color="primary"
                          component="label"
                          htmlFor="file-upload"
                        >
                          Browse
                        </ButtonTheme>
                      </InputAdornment>
                    ),
                  }}
                  placeholder="No file chosen"
                  InputLabelProps={{ shrink: true }}
                />
              </Box>
            </Stack>
          </Grid>
        </Grid>
        <Box className="d-flex gap-4 mt-3">
          <ButtonTheme
            variant="contained"
            color="primary"
            component="label"
            className="py-2 px-4"
          >
            Add Item
          </ButtonTheme>
          <ButtonTheme
            type="button"
                variant="filled"
                // color="transparent"
            className="px-3"
          >
            Cancel
          </ButtonTheme>
        </Box>
      </Card> */}

      <Card className="shadow p-3 " style={{ marginTop: "1rem" }}>
        <Grid className="d-flex justify-content-between">
          <h5>
            Item List
          </h5>
          <img src="/images/printer.svg"></img>
        </Grid>
        <Grid container spacing={3} className="mx-0 my-4">
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className="p-0 pe-2 mb-3 me-4 d-none d-md-block"
          >
            <Stack spacing={1}>
              <TextField
                select
                fullWidth
                label="Location"
                InputProps={{
                  style: {
                    borderRadius: "8px",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <img
                        src="/images/arrow-icon.svg"
                        style={{ transform: "rotate(90deg" }}
                      />
                    </InputAdornment>
                  ),
                }}
                SelectProps={{
                  IconComponent: () => null,
                }}
              >
                <MenuItem value="location1">Location 1</MenuItem>
                <MenuItem value="location2">Location 2</MenuItem>
              </TextField>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6} md={4} className="p-0 pe-2 mb-3 me-4">
            <Box border={1} borderColor="#CCCCCC" borderRadius={2} p={1.4}>
              <TextField
                variant="standard"
                placeholder="Search by keyword"
                fullWidth
                style={{ border: "none" }}
                InputProps={{
                  endAdornment: <SearchIcon fontSize="small" />,
                }}
                InputLabelProps={{ shrink: true }}
                sx={{
                  "& .MuiInputBase-root::before": {
                    borderBottom: "none",
                  },
                  "& .MuiInputBase-root::after": {
                    borderBottom: "none",
                  },
                  "& .MuiInputBase-root:hover:not(.Mui-disabled)::before": {
                    borderBottom: "none",
                  },
                }}
              />
            </Box>
          </Grid>
        </Grid>
        {isMobile ? (
          <InventoryTable rows={rows || {}} columns={columns} heading={1} />
        ) : (
          <MyTable
            rows={rows || []}
            columns={columns}
            checkboxSelection={false}
            // loading={tableLoading}
            hideFooter={true}
            className="mt-4"
          />
        )}
      </Card>
      <div className="mt-4 d-flex justify-content-between">
        <Typography>Showing 1-10 from 3 data</Typography>
        <PaginationComponent results={rows || []} />
      </div>
    </>
  );
};

export default AddItem;
